/**
 * 用户登录
 * @param {any} data
 * @returns {Promise}
 */
export function login(data) {
  return ZP.Ajax({
    url: '/api/user/manage/login',
    method: 'post',
    data,
  });
}

/**
 * 在平台后台自动登录CRM系统
 * @returns {Promise}
 */
export function syncLoginCRM() {
  return ZP.Ajax({
    url: '/api/user/manage/index/syncCrm',
  });
}

/**
 * 退出登录
 * @returns {Promise}
 */
export function userLogout() {
  return ZP.Ajax({
    url: '/api/user/manage/logout',
  });
}

/**
 * 修改密码
 * @param {any} data
 * @returns {Promise}
 */
export function changePassword(data) {
  return ZP.Ajax({
    url: '/api/user/manage/pwd/modify',
    method: 'put',
    data,
  });
}

/**
 * 获取用户信息
 * @returns {Promise}
 */
export function getUserInfo() {
  return ZP.Ajax({
    url: '/api/user/manage/login/info',
  });
}

/**
 * 添加用户时检验手机号是否注册
 * @param {any} { phone, userId = null}
 * @returns {Promise}
 */
export function getPhoneStatus(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/validPhone',
    data,
  });
}

/**
 * 获取平台列表: 平台、品牌商、经销商、c端
 * @returns {Promise}
 */
export function getPlatfromList() {
  return ZP.Ajax({
    url: '/api/user/manage/platform/list',
  });
}
